import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { getCookieValue } from "src/constants/functions";
import { api, medvolApiUrl, vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";

const instance: AxiosInstance = axios.create({
  baseURL: api,
});

const companyserviceurl: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl + "/api/v1/oms",
});

const basecompanyserviceurl: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl,
});

const companyserviceurlevent: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl,
});

const medvolInstance: AxiosInstance = axios.create({
  baseURL: medvolApiUrl,
});

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
basecompanyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurlevent.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

export const fetchInvoicesData = ({
  startDate,
  endDate,
  company_code,
  division_code,
  assignee_id,
  city,
  district,
  state,
  ordering,
  fuid_no,
  fuid_status_id,
  invoice_number,
  order_no,
  counter_code,
  stockist_medvol_code,
  company_stockist_code,
  page_size,
  page_number,
  screen,
  dateType,
  entered_by,
  approved_by,
  is_escalated,
  textract_configured  //textract filter
}: any) => {
  return companyserviceurl.get(`/stockist_attachment/all`, {
    params: {
      company_code: company_code,
      division_code: division_code,
      date_from: startDate,
      date_to: endDate,
      invoice_assignment_id: assignee_id,
      city: city,
      district: district,
      state: state,
      ordering: ordering,
      fuid_no: fuid_no,
      fuid_status_id: fuid_status_id,
      invoice_number: invoice_number,
      order_no: order_no,
      counter_code: counter_code,
      stockist_medvol_code: stockist_medvol_code,
      company_stockist_code: company_stockist_code,
      page_size: page_size,
      page: page_number,
      screen: screen,
      date_type: dateType,
      entered_by: entered_by,
      approved_by: approved_by,
      is_escalated: is_escalated,
      textract_configured: textract_configured  //textract filter
    },
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const fetchPriorityInvoicesData = ({
  startDate,
  endDate,
  company_code,
  division_code,
  assignee_id,
  city,
  district,
  state,
  ordering,
  fuid_no,
  fuid_status_id,
  invoice_number,
  order_no,
  counter_code,
  stockist_medvol_code,
  company_stockist_code,
  page_size,
  page_number,
  screen,
  dateType,
  entered_by,
  approved_by,
  textract_configured  //textract filter
}: any) => {
  return companyserviceurl.get(`/stockist_attachment/all?is_prioritised=true`, {
    params: {
      company_code: company_code,
      division_code: division_code,
      date_from: startDate,
      date_to: endDate,
      invoice_assignment_id: assignee_id,
      city: city,
      district: district,
      state: state,
      ordering: ordering,
      fuid_no: fuid_no,
      fuid_status_id: fuid_status_id,
      invoice_number: invoice_number,
      order_no: order_no,
      counter_code: counter_code,
      stockist_medvol_code: stockist_medvol_code,
      company_stockist_code: company_stockist_code,
      page_size: page_size,
      page: page_number,
      screen: screen,
      date_type: dateType,
      entered_by: entered_by,
      approved_by: approved_by,
      textract_configured: textract_configured  //textract filter
    },
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const fetchEscalatedInvoicesData = ({
  startDate,
  endDate,
  company_code,
  division_code,
  assignee_id,
  city,
  district,
  state,
  ordering,
  fuid_no,
  fuid_status_id,
  invoice_number,
  order_no,
  counter_code,
  stockist_medvol_code,
  company_stockist_code,
  page_size,
  page_number,
  screen,
  dateType,
  entered_by,
  approved_by,
  textract_configured  //textract filter
}: any) => {
  return companyserviceurl.get(`/stockist_attachment/all?is_escalated=true`, {
    params: {
      company_code: company_code,
      division_code: division_code,
      date_from: startDate,
      date_to: endDate,
      invoice_assignment_id: assignee_id,
      city: city,
      district: district,
      state: state,
      ordering: ordering,
      fuid_no: fuid_no,
      fuid_status_id: fuid_status_id,
      invoice_number: invoice_number,
      order_no: order_no,
      counter_code: counter_code,
      stockist_medvol_code: stockist_medvol_code,
      company_stockist_code: company_stockist_code,
      page_size: page_size,
      page: page_number,
      screen: screen,
      date_type: dateType,
      entered_by: entered_by,
      approved_by: approved_by,
      textract_configured: textract_configured
    },
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getInvoiceDetails = (stockist_invoice_attachment_id: string, products: boolean, company_code: number | string | undefined) => {
  return companyserviceurl.get(
    `/stockist_attachment/details?stockist_invoice_attachment_id=${stockist_invoice_attachment_id}&invoice_id=&products=${products}`,
    {
      headers: {
        company_code: company_code || 0,
      },
    }
  );
};

export const downloadInvoice = (file_path: string, company_code: string | number) => {
  return companyserviceurl.get(`/stockist_attachment/get-file?file_key=${file_path}`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const uploadInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/invoice/add`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

//Not using
export const updateInvoice = (payload: any) => {
  return companyserviceurlevent.post(`event/invoice/product-add`, payload);
};

export const rejectInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/reject`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};
// MEDVOL: M10-11303 changes ========================================
export const escalatedCompany = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/escalated-company`, payload, {
    headers: {
      company_code: company_code || 0
    },
  });
};
// MEDVOL: M10-11303 changes ========================================

export const getRejectionCategory = (company_code: string | number) => {
  return companyserviceurlevent.get(`api/v1/oms/stockist_attachment/reject-categories`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getAssigneeList = (company_code: string | number) => {
  return companyserviceurl.get("/stockist_attachment/invoice-assignees", {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const reAssignInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/reassign`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const escalateInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/escalate`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const setPriorityInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/set-priority`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const putInvoiceOnHold = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.put(`/event/stockist_attachment/hold`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};
//Lupin Add company code
export const fetchInvoiceStatus = (company_code: number) => {
  return companyserviceurl.get(`/stockist_attachment/fuid-status-list`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getSimilarCompanyProducts = (company_code: string, product_name: string, product_code: string, page: number, page_size: number) => {
  return instance.get(
    `/oms/counter/company/products?company_code=${company_code}&product_name=${product_name}&item_code=${product_code}&page=${page}&page_size=${page_size}`
  );
};

export const entryInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.put(`/event/invoice/entry`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const editInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.put(`/event/invoice/edit`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getOrderedProducts = (payload: any) => {
  return companyserviceurlevent.get(
    `/api/v1/oms/order/similar-products?counter_code=${payload?.counter_code}&product_name=${payload?.product_name}&page=${payload?.page}&page_size=${payload?.page_size}&company_stockist_code=${payload?.company_stockist_code}&invoice_date=${payload?.invoice_date}`, {
    headers: {
      company_code: payload?.company_code || 0,
    },
  }
  );
};

export const getSimilarOrders = (payload: any) => {
  return companyserviceurl.get(
    `/order/similar-orders?item_code=${payload?.item_code}&inv_mrp=${payload?.inv_mrp}&counter_code=${payload?.counter_code}&company_stockist_code=${payload?.company_stockist_code}&invoice_date=${payload?.invoice_date}`, {
    headers: {
      company_code: payload?.company_code || 0,
    },
  }
  );
};

//Not using
export const editInvoiceProduct = (payload: any) => {
  return companyserviceurlevent.post(`/event/invoice/product-edit`, payload);
};

//Not using
export const invoiceProductDelete = (payload: any) => {
  return companyserviceurlevent.delete(`/event/invoice/product-delete`, { data: payload });
};

export const getInvoiceBatchList = (itemCode: string, company_code: string | number) => {
  return companyserviceurl.get(`/invoice/product-batch?item_code=${itemCode}`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getInvoicePriceList = (itemCode: string) => {
  return instance.get(`/api/v1/product/get-product-price?is_active=true&item_code=${itemCode}`);
};

export const fetchEinvoicesData = ({
  page_size,
  page_number,
  einvoice_dtl_id,
  company_code,
  division_code,
  startDate,
  endDate,
  assignee_id,
  city,
  district,
  state,
  einvoice_status,
  invoice_number,
  counter_code,
  fuid_no,
  stockist_medvol_code,
  company_stockist_code,
  attachment_type,
}: any) => {
  return companyserviceurl.get(`/stockist_attachment/e-invoices?`, {
    params: {
      page_size: page_size,
      page: page_number,
      einvoice_dtl_id: einvoice_dtl_id || null,
      company_code: company_code,
      division_code: division_code,
      date_from: startDate,
      date_to: endDate,
      invoice_assignment_id: assignee_id,
      city: city,
      district: district,
      state: state,
      einvoice_status: einvoice_status,
      invoice_number: invoice_number,
      counter_code: counter_code,
      fuid_no: fuid_no,
      stockist_medvol_code: stockist_medvol_code,
      company_stockist_code: company_stockist_code,
      attachment_type: attachment_type,
    },
    headers: {
      company_code: company_code,
    },
  });
};

export const eInvoiceStatusUpdate = (payload: any) => {
  return companyserviceurlevent.put(`/event/stockist_attachment/e-invoice-status-update`, payload);
};
//M10-11536
export const getInvoiceRemarks = (stockist_invoice_attachment_id: number, company_code: string | number) => {
  return companyserviceurl.get(`/stockist_attachment/remarks?stockist_invoice_attachment_id=${stockist_invoice_attachment_id}`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const postInvoiceRemark = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/stockist_attachment/remark`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};
//M10-11536

//Not using
export const invoiceStatusUpdate = (payload: any) => {
  return companyserviceurlevent.put(`event/stockist_attachment/status-update`, payload);
};

export const revertInvoice = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.put(`event/invoice/revert`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const multiInvoiceReassign = (payload: any, company_code: string | number) => {
  return basecompanyserviceurl.put(`multi-event/stockist_attachment/reassign`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const recallInvoice = (payload: any, company_code: string | number) => {
  return basecompanyserviceurl.delete(`event/invoice/recall`, {
    data: payload,
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const searchProduct = (payload: any) => {
  return instance.get(
    `/api/v1/product/search?search=${payload?.search}&page=${payload?.page}&perPage=${payload?.perPage}&company_code=${payload?.company_code}`
  );
};

export const stockistProductMap = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.post(`/event/invoice/stockist-product-map`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getTextractData = (fuid_no: string, company_code: string | number) => {
  return companyserviceurl.get(`/stockist_attachment/textract?fuid=${fuid_no}`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getAnalyticsData = (company_code: string | number) => {
  return companyserviceurl.get(`/stockist_attachment/analytics`, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getProductGstDetails = (item_codes: string) => {
  return instance.get(`/api/v1/product/details?item_codes=${item_codes}&fields=company_productcode%2Citem_code%2Cname%2Cgst_pc%2Cgst_ambiguous`);
};

// export const getInvoiceUsers = (keys: string, entered_by: string, approved_by: string) => {
//   return companyserviceurl.get(`/invoice/?keys=${keys}&entered_by=${entered_by}&approved_by=${approved_by}`);
// };

export const getInvoiceUsers = (query: string, company_code: string | number) => {
  return companyserviceurl.get(query, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getInvoiceActionAllowed = (invoice_id: string, stockist_invoice_attachment_id: string, action: string, company_code: string | number) => {
  return companyserviceurl.get(`/invoice/is-action-allowed?invoice_id=${invoice_id}&stockist_invoice_attachment_id=${stockist_invoice_attachment_id}&action=${action}`, {
    headers: {
      company_code: company_code || 0,
    },
  })
}

export const eInvoiceEdit = (payload: any) => {
  return companyserviceurlevent.put(`/event/stockist_attachment/e-invoice-edit`, payload);
};

export const eInvoiceExemptUpdate = (payload: any) => {
  return companyserviceurlevent.put(`/event/order/einvoice`, payload);
};

export const saoExemptUpdate = (payload: any, company_code: string) => {
  return companyserviceurlevent.put(`/event/order/sao_exempt`, payload, {
    headers: {
      company_code: company_code || 0,
    }
  })
};

export const getInvoiceChangeValidationV1 = (payload: any) => {
  const token = getCookieValue("idToken");

  if (!token) throw new Error("No token found");

  return medvolInstance.post(`/api/invoicevalidation`, payload, {
    headers: {
      Authorization: token,
    },
  });
};

export const autoInvoiceEntry = (payload: any, company_code: string | number) => {
  return companyserviceurlevent.put(`/event/invoice/auto-invoice-entry`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  })
};

export const checkPoStatus = (payload: any, token: string) => {
  return medvolInstance.post(`/api/checkinvoice_replenishmentv2`, payload, {
    headers: {
      Authorization: token,
    },
  });
};

export const escalateInvoiceToMaster = (payload: any, company_code: string | number) => {
  return companyserviceurl.post(`/stockist_attachment/master-escalation`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getMasterEscalationList = (payload: any) => {
  return companyserviceurl.get(`/stockist_attachment/master-escalation`, {
    params: {
      page: payload?.page,
      page_size: payload?.page_size,
      invoice_number: payload?.invoice_number,
      status: payload?.status,
      fuid: payload?.fuid,
      pharmacist_code: payload?.pharmacist_code,
      link_type: payload?.link_type,
      entry_type: payload?.entry_type,
      counter_code: payload?.counter_code,
      stockist_id: payload?.stockist_id,
      sort: payload?.sort,
      date: payload?.dateRange,
      company_code: payload?.company_code,
      remark_type: payload?.remark_type
    },
    headers: {
      company_code: payload?.company_code || 0,
    },
  });
};

export const closeInvoiceEscalation = (payload: any, company_code: string | number) => {
  return companyserviceurl.put(`/stockist_attachment/master-escalation`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const fetchTextractData = ({
  startDate,
  endDate,
  company_code,
  division_code,
  assignee_id,
  city,
  district,
  state,
  ordering,
  fuid_no,
  fuid_status_id,
  page_size,
  page_number,
  screen,
  dateType,
  entered_by,
  approved_by,
  stockist_medvol_code,
  textract_configured
}: any) => {
  return companyserviceurl.get(`/stockist_attachment/textract-stockist`, {
    params: {
      company_code: company_code,
      division_code: division_code,
      date_from: startDate,
      date_to: endDate,
      invoice_assignment_id: assignee_id,
      city: city,
      district: district,
      state: state,
      ordering: ordering,
      fuid_no: fuid_no,
      fuid_status_id: fuid_status_id,
      page_size: page_size,
      page: page_number,
      screen: screen,
      date_type: dateType,
      entered_by: entered_by,
      approved_by: approved_by,
      stockist_medvol_code: stockist_medvol_code,
      textract_configured: textract_configured
    },
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const getRemarkHeader = () => {
  return companyserviceurl.get(`/stockist_attachment/escalation-reason`);
};
//M10-10639
export const getCheckFullyInvoiced = (invoice_id: any, company_code: any, payload: any) => {
  return companyserviceurl.post(`/invoice/check-fully-invoiced?invoice_id=${invoice_id}`, payload, {
    headers: {
      company_code: company_code || 0,
    },
  });
};
//M10-10639